export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  iconItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    margin: 5,
  },
  noQuestionsContainer: {
    textAlign: 'center',
  },
  noQuestions: {
    height: 150,
    fontSize: 250,
    color: 'lightgrey',
  },
  body: {
    padding: 20,
  },
  type: {
    padding: 5,
  },
  typeName: {
    // lineHeight: 23,
  },
  typeDesc: {
    fontSize: 12,
  },
};



// WEBPACK FOOTER //
// ./src/components/QualityControlQuestionDialog/styles.js